/*
 * Public API Surface of pepperi-lib/image
 */
export * from './image.module';
export * from './image.component';
